import { render, staticRenderFns } from "./break_list.vue?vue&type=template&id=a948edfe&scoped=true&"
import script from "./break_list.vue?vue&type=script&lang=js&"
export * from "./break_list.vue?vue&type=script&lang=js&"
import style0 from "./break_list.vue?vue&type=style&index=0&id=a948edfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a948edfe",
  null
  
)

export default component.exports